import { useState, useEffect } from "react";
import { Col, Row, Modal, DatePicker } from "antd";
import { format } from "date-fns";
import { UseUser } from "../hooks";
import { GetFetchReporteCierreDia } from "../Api/GetReporteCierreDia";
import { FormDetailsReport } from "./FormDetailsReport";
import { GetFetchMarcas } from "../Api/Administracion/GetFetchMarcas";
import { fetchGetItemReporteCierreDia } from "../Api/fetchGetItemReporteCierreDia";
import { fetReporteCvsCierreDia } from "../Api/fetReporteCvsCierreDia";
import { GetFetchSucursalesBymarca } from "../Api/Administracion/GetFetchSucursalesByMarca";
import "react-responsive-modal/styles.css";
import "../theme/ReporteCierreDia.css";
import "../theme/Pagination.css";
import { InputSelectWithInName } from "./utils/InputSelectWithInName";
import { CustomDataTable } from "./Tables/CustomDataTable";
import { icons } from "../const/icons";
import locale from "antd/es/date-picker/locale/es_ES";
import "moment/locale/es";
import { CalendarIcon } from "./shared/CalendarIcon";

export const TableReportes = () => {
  // Estados de carga
  const [isLoadingSucursal, setIsLoadingSucursal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Estados de datos
  const [data, setData] = useState();
  const [dataMarca, setDataMarca] = useState([]);
  const [dataSucursal, setDataSucursal] = useState([]);

  // Estados de modal
  const [selectedItem, setSelectedItem] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // Estados de formulario
  const [formData, setFormData] = useState({
    pais: 1,
    marca: 0,
    sucursal: 0,
  });

  const [formDataDate, setFormDataDate] = useState({
    inicio: null,
    fin: null,
  });

  const canConsultar =
    formData.marca !== 0 && formDataDate.inicio !== null && formDataDate.fin !== null;

  // Hooks
  const { mail } = UseUser();

  // Cálculo de fechas límite
  const today = new Date();
  const minDate = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());

  let fechaFin = new Date(today);
  if (formDataDate.inicio) {
    const maxEndDate = new Date(formDataDate.inicio);
    maxEndDate.setDate(formDataDate.inicio.getDate() + 6);
    fechaFin = new Date(Math.min(maxEndDate, today));
  }

  // Effects
  useEffect(() => {
    fetchDataMarca();
  }, []);

  useEffect(() => {
    fetchDataSucursal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.marca]);

  // Handlers de cambio
  const handleChangeDate = (date, type) => {
    setFormDataDate((prev) => ({
      ...prev,
      [type]: date ? date.toDate() : null,
    }));
  };

  const handleChange = (event, name) => {
    if (event.target) {
      const { name, value } = event.target;
      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: event });
    }
  };

  // Funciones de fetch
  const fetchDataMarca = async () => {
    const onFailure = (error) => {
      /*eslint-disable-next-line no-console*/
      console.log(error);
    };

    const onSuccess = ({ data }) => {
      setDataMarca(data.body.data);
    };

    GetFetchMarcas(true).then(onSuccess).catch(onFailure);
  };

  const fetchDataSucursal = async () => {
    if (formData.marca !== 0) {
      setIsLoadingSucursal(true);

      const onFailure = (error) => {
        setIsLoadingSucursal(false);
      };

      const onSuccess = ({ data }) => {
        setDataSucursal(data.body.data);
        setIsLoadingSucursal(false);
      };

      GetFetchSucursalesBymarca(formData.marca).then(onSuccess).catch(onFailure);
    }
  };

  const getReportData = () => {
    setIsLoading(true);

    if (formData.marca !== 0 && formDataDate.inicio !== "" && formDataDate.fin !== "") {
      const inicio = formatDate(formDataDate.inicio);
      const fin = formatDate(formDataDate.fin);
      const marca = Number(formData.marca);
      const sucursal = formData.sucursal;

      const onFailure = (error) => {
        setIsLoading(false);
      };

      const onSuccess = ({ data }) => {
        setData(data.records);
        setIsLoading(false);
      };

      GetFetchReporteCierreDia(Number(formData.pais), marca, sucursal, inicio, fin)
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  const getReportDataCvs = () => {
    if (formData.marca !== 0 && formDataDate.inicio !== "" && formDataDate.fin !== "") {
      const inicio = formatDate(formDataDate.inicio);
      const fin = formatDate(formDataDate.fin);
      const marca = Number(formData.marca);
      const sucursal = formData.sucursal;

      fetReporteCvsCierreDia(Number(formData.pais), marca, sucursal, inicio, fin, mail);

      setTimeout(() => {
        alert(
          "Tu solicitud está siendo procesada. Pronto recibirás un informe detallado en tu correo electrónico"
        );
      }, 2000);
    }
  };

  const getItemReportData = (item) => {
    if (item) {
      const partes = item?.fechaRegistro.split(" ");
      const fechaRegistro = partes[0];
      const marca = Number(item.marca);
      const sucursal = item.sucursal;

      const onFailure = (error) => {
        /*eslint-disable-next-line no-console*/
        console.log("error", error);
      };

      const onSuccess = ({ data }) => {
        handleOpenModal(data.records);
      };

      fetchGetItemReporteCierreDia(Number(formData.pais), marca, sucursal, fechaRegistro)
        .then(onSuccess)
        .catch(onFailure);
    }
  };

  // Handlers de modal
  const handleOpenModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  // Utilidades de formato
  const formatDate = (date) => {
    return format(date, "dd/MM/yyyy");
  };

  const FormateData = ({ item }) => {
    const [datePart] = item.split(" ");
    const [day, month, year] = datePart.split("/");
    const formattedDate = `${day}/${month}/${year}`;
    return <span className="accent-field">{formattedDate}</span>;
  };

  const FormatCurrency = ({ value }) => {
    const formattedCurrency = parseFloat(value).toLocaleString("es-MX", {
      style: "currency",
      currency: "MXN",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    });
    return <span>{formattedCurrency}</span>;
  };

  // Configuración de columnas
  const columns = [
    {
      title: "Fecha Registro",
      dataIndex: "fechaRegistro",
      key: "fechaRegistro",
      render: (item) => <FormateData item={item} />,
      onCell: () => ({
        style: { borderRight: "2px dashed #d1d5db" },
      }),
    },
    {
      title: "Fecha Modificacion",
      dataIndex: "fechaModificacion",
      key: "fechaModificacion",
    },
    {
      title: "CECO",
      dataIndex: "sucursal",
      key: "sucursal",
    },
    {
      title: "Nombre Tienda",
      dataIndex: "nombreTienda",
      key: "nombreTienda",
    },
    {
      title: "Venta Total",
      dataIndex: "ventaTotal",
      key: "ventaTotal",
      render: (value) => <FormatCurrency value={value} />,
    },
    {
      title: "Deposito Tombola",
      dataIndex: "depositoTombola",
      key: "depositoTombola",
      render: (value) => <FormatCurrency value={value} />,
    },
    {
      title: "Efectivo a Depositar",
      dataIndex: "efectivoADepositar",
      key: "efectivoADepositar",
      render: (value) => <FormatCurrency value={value} />,
    },
    {
      title: "Ver Detalle",
      // align: "center",
      render: (item) => (
        <button onClick={() => getItemReportData(item)} className="button-styles-detalais-catalogo">
          <img src={icons.edit} alt="Ver Detalle" className="edit-icon" />
        </button>
      ),
      fixed: "right",
      width: "10%",
    },
  ];

  return (
    <>
      <div className="reportes-container">
        {/* Card de Filtros */}
        <div className="reportes-card">
          <header className="reportes-card-header">
            <h2 className="reportes-card-title">Reporte cierre de día</h2>
          </header>

          <div className="reportes-filters-body">
            <Row gutter={[16, 16]} justify="start" align="middle">
              {/* Marcas */}
              <Col xs={24} sm={12} md={6} lg={5}>
                <div className="filter-group">
                  <label className="filter-label">Marcas</label>
                  <InputSelectWithInName
                    value={formData.marca}
                    handleChange={handleChange}
                    options={dataMarca}
                    label=""
                    optionsKey="FIMARCAID"
                    optionsName="FCNOMBRE"
                    name="marca"
                  />
                </div>
              </Col>

              {/* Sucursales */}
              <Col xs={24} sm={12} md={6} lg={5}>
                <div className="filter-group">
                  <label className="filter-label">Sucursales</label>
                  <select
                    className="input-content-select"
                    value={formData.sucursal}
                    onChange={handleChange}
                    name="sucursal"
                    disabled={formData.marca === 0 || isLoadingSucursal}
                  >
                    <option value="0">Seleccionar Todas</option>
                    {dataSucursal.map((option) => (
                      <option key={option.FISUCURSALID} value={option.FISUCURSALID}>
                        {option.FISUCURSALID}-{option.FCNOMBRE}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>

              {/* Fecha Inicio */}
              <Col xs={24} sm={12} md={6} lg={5}>
                <div className="filter-group">
                  <label className="filter-label">Fecha Inicio</label>

                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    locale={locale}
                    selected={formDataDate.inicio}
                    onChange={(date) => handleChangeDate(date, "inicio")}
                    selectsStart
                    startDate={formDataDate.inicio}
                    endDate={formDataDate.fin}
                    minDate={minDate}
                    maxDate={fechaFin}
                    placeholderText="Seleccionar fecha"
                    className="input-content-select-picker"
                    suffixIcon={
                      <CalendarIcon className="calendar-icon" color="var(--color-text)" />
                    }
                  />
                </div>
              </Col>

              {/* Fecha Fin */}
              <Col xs={24} sm={12} md={6} lg={5}>
                <div className="filter-group">
                  <label className="filter-label">Fecha Fin</label>

                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    locale={locale}
                    selected={formDataDate.fin}
                    onChange={(date) => handleChangeDate(date, "fin")}
                    selectsEnd
                    startDate={formDataDate.inicio}
                    endDate={formDataDate.fin}
                    minDate={formDataDate.inicio ? new Date(formDataDate.inicio) : minDate}
                    maxDate={fechaFin}
                    placeholderText="Seleccionar fecha"
                    className="input-content-select-picker"
                    suffixIcon={
                      <CalendarIcon className="calendar-icon" color="var(--color-text)" />
                    }
                  />
                </div>
              </Col>

              {/* Botones de acción */}
              <Col xs={24} sm={24} md={12} lg={4}>
                <div className="filter-actions">
                  <button
                    className="button-consultar"
                    type="button"
                    onClick={getReportData}
                    disabled={!canConsultar}
                  >
                    <img src={icons.search} alt="Consultar" className="search-img" />
                  </button>

                  <button
                    className="button-generar-csv"
                    type="button"
                    onClick={getReportDataCvs}
                    disabled={!canConsultar}
                  >
                    Generar CSV
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Tabla de Resultados */}
        <div className="reportes-card">
          <CustomDataTable
            data={data || []}
            columns={columns}
            loading={isLoading}
            showPagination={false}
            rowKey={(record) =>
              `${record.sucursal}${record.fechaRegistro}${record.fechaModificacion}`
            }
            scroll={{ x: 1400, y: 600 }}
          />
        </div>
      </div>

      {/* Modal de Detalles */}
      <Modal
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={null}
        width={1000}
        style={{ left: "0" }}
      >
        <FormDetailsReport
          selectedItem={selectedItem}
          getReportData={getReportData}
          setShowModal={setShowModal}
        />
      </Modal>
    </>
  );
};
